import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FiaService } from 'src/app/services/fia.service';
import { MediaService } from 'src/app/services/media.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UserAitService } from 'src/app/services/user-ait.service';
import { UserAitSearchResponse } from 'src/app/shared/models/users/user-ait-search-response';
import { MediaInfo } from 'src/app/shared/models/general/media-info';
import { HttpErrorResponse } from '@angular/common/http';
import { UserAitSearchRequest } from 'src/app/shared/models/users/user-ait-search-request';
import { LookupBanks } from 'src/app/shared/models/general/lookup-banks';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-ait',
  templateUrl: './ait.component.html',
  styleUrls: ['./ait.component.scss'],
})
export class AitComponent {
  errorResponse: HttpErrorResponse;
  showError: boolean = false;

  //File selector
  @ViewChild('file') file;

  pageBusy: boolean = true;
  modalBusy: boolean = false;

  //General
  userAitSearchRequest: UserAitSearchRequest = new UserAitSearchRequest();

  userAitSearchResponse: UserAitSearchResponse[] = [];
  mediaInfo: MediaInfo = new MediaInfo();
  searchText: string = '';
  aitHistoryMonths: number = 6;
  includeExpiredPins: boolean = false;

  constructor(
    private router: Router,
    public settingsService: SettingsService,
    public userAitService: UserAitService,
    public userService: UserService,
    public fiaService: FiaService,
    public mediaService: MediaService
  ) {
    this.pageBusy = true;
    this.settingsService.ValidateGlobalVars().then(() => {
      this.settingsService.GetLookupFiaStatus().then(() => {
        this.settingsService.GetLookupMediaTypes().then(() => {
          if (!this.settingsService.userIsBroker) {
            //Redirect to login
            this.router.navigate(['/login']);
          }
          //this sets up some search defaults
          this.userAitSearchRequest.entityType = this.settingsService.brokerEntity.id;
          this.userAitSearchRequest.entityId = this.settingsService.brokerUsers[0].brokerId;
          this.userAitSearchRequest.bankId = new LookupBanks().GetBankById(7).id; // Capitec

          this.SearchUserAit();
        });
      });
    });
  }

  SearchUserAit() {
    this.pageBusy = true;
    this.userAitService.SearchUserAitInfo(this.userAitSearchRequest).subscribe({
      next: (response) => {
        this.userAitSearchResponse = response;
        this.pageBusy = false;
        this.showError = false;
      },
      error: (error) => {
        this.errorResponse = error;
        this.pageBusy = false;
        this.showError = true;
      },
    });
  }

  GenerateLastApprovedPinDoc(user: UserAitSearchResponse) {
    user.isGeneratingLastApprovedPinDoc = true;
    this.mediaService.GenerateLastApprovedPinDoc(user.userId).subscribe({
      next: (response: MediaInfo) => {
        this.mediaInfo = response;
        this.mediaService.Download(this.mediaInfo);
        this.showError = false;
        user.isGeneratingLastApprovedPinDoc = false;
      },
      error: (error) => {
        this.errorResponse = error;
        this.showError = true;
        user.isGeneratingLastApprovedPinDoc = false;
      },
    });
  }

  GenerateAITFullHistoryDoc(user: UserAitSearchResponse) {
    user.isGeneratingAITHistoryDoc = true;
    this.mediaService.GenerateAITFullHistoryDoc(user.userId, this.aitHistoryMonths, this.includeExpiredPins).subscribe({
      next: (response: MediaInfo) => {
        this.mediaInfo = response;
        this.mediaService.Download(this.mediaInfo);
        this.showError = false;
        user.isGeneratingAITHistoryDoc = false;
      },
      error: (error) => {
        this.errorResponse = error;
        this.showError = true;
        user.isGeneratingAITHistoryDoc = false;
      },
    });
  }

  GetUserBankBalance(userAit: UserAitSearchResponse) {
    userAit.isUpdating = true;
    this.userService.UpdateBankAccountBalance(userAit.accountNumber).subscribe({
      next: (updatedUserAit: UserAitSearchResponse) => {
        this.handleRecordUpdate(userAit, updatedUserAit);
      },
      error: (err) => {
        userAit.error = err;
        this.errorResponse = err;
        this.showError = true;
        userAit.isUpdating = false;
      },
    });
  }

  ShowModal(userId: number, Modal: string) {
    this.modalBusy = true;
    this.modalBusy = false;
  }

  HideModal() {}

  popupError(error: HttpErrorResponse) {
    //Note: the spread operator here ... creates a new instance of the error so that the onChanges can detect the change in the errorcomponent
    this.errorResponse = { ...error };
    this.showError = true;
  }

  private handleRecordUpdate(userAit: UserAitSearchResponse, updatedUserAit: UserAitSearchResponse) {
    userAit.balance = updatedUserAit.balance;
    userAit.balanceDate = updatedUserAit.balanceDate;
    userAit.recentlyUpdated = true;
    userAit.updateSuccess = true;
    userAit.isUpdating = false;
    setTimeout(() => {
      userAit.recentlyUpdated = false;
    }, 3000);
  }
  editableUserResponse: boolean;
  editMode = false;
  editedUserResponse: UserAitSearchResponse | null;
  editField(userResponse: UserAitSearchResponse) {
    this.editMode = true;
    this.editedUserResponse = userResponse;
  }

  saveRecord(userAit: UserAitSearchResponse) {
    userAit.error = null;
    userAit.recentlyUpdated = false;
    userAit.isUpdating = true;
    this.editMode = false;
    this.editedUserResponse = null;

    this.userService.ManualUpdateBankAccountBalance(userAit.accountNumber, userAit.manuallyAddedBalance).subscribe({
      next: (response) => {
        this.handleRecordUpdate(userAit, response);
      },
      error: (error) => {
        userAit.isUpdating = false;
        userAit.error = error;
        this.popupError(userAit.error);
      },
    });
  }
}
